import PropTypes from 'prop-types';
//TODO: remove when migrated to TS
const TREE_FULL_WIDTH_SYMBOL_ID = 1;
const TREE_PAGE_SYMBOL_ID = 2;
const TREE_TABBED_PAGE_SYMBOL_ID = 3;
export const treeLayoutProps = {
    // Enum symbol representation
    treeLayoutType: PropTypes.oneOf([
        TREE_FULL_WIDTH_SYMBOL_ID,
        TREE_PAGE_SYMBOL_ID,
        TREE_TABBED_PAGE_SYMBOL_ID,
    ]),
};
//TODO: end
export var TreeLayoutTypeEnum;
(function (TreeLayoutTypeEnum) {
    TreeLayoutTypeEnum[TreeLayoutTypeEnum["TREE_FULL_WIDTH"] = 0] = "TREE_FULL_WIDTH";
    TreeLayoutTypeEnum[TreeLayoutTypeEnum["TREE_PAGE"] = 1] = "TREE_PAGE";
    TreeLayoutTypeEnum[TreeLayoutTypeEnum["TREE_TABBED_PAGE"] = 2] = "TREE_TABBED_PAGE";
})(TreeLayoutTypeEnum || (TreeLayoutTypeEnum = {}));
const TreeLayoutConfigsDictionary = {
    [TreeLayoutTypeEnum.TREE_FULL_WIDTH]: {
        treeClassName: 'col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12',
    },
    [TreeLayoutTypeEnum.TREE_PAGE]: {
        treeClassName: 'col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12',
        editNodeClassName: 'col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12',
        searchFieldWidthClassName: 'col-lg-4 col-md-4 col-sm-6 col-xs-12',
    },
    [TreeLayoutTypeEnum.TREE_TABBED_PAGE]: {
        treeClassName: 'col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12',
        editNodeClassName: 'col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12',
        searchFieldWidthClassName: 'col-lg-4 col-md-4 col-sm-6 col-xs-12',
    },
};
export function getTreeLayoutConfig(layout) {
    const config = TreeLayoutConfigsDictionary[layout];
    if (!config) {
        throw new Error(`Unsupported layout '${layout}'`);
    }
    return config;
}
